import * as API from "@/services/API";

export default {
    getCredits(regionId?: number) { // @TODO: implement regionId specific querying
        return API.apiClient.get(`/user/credits`);
    },
    uploadAvatar(formData: FormData) {
        return API.apiClient.post(`/user/avatar`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    deleteProfile(password: string) {
        return API.apiClient.post(`/user/delete`, { password });
    }
}
